import { createAction, props } from '@ngrx/store';
import { Farm } from '../_models';

// Azioni per l'utente corrente
export const loadCurrentFarm = createAction(
  '[Farm] Load Current Farm',
  props<{ forceReload: boolean }>()
);
export const loadCurrentFarmSuccess = createAction(
  '[Farm] Load Current Farm Success',
  props<{ farm: Farm }>()
);
export const loadCurrentFarmFailure = createAction(
  '[Farm] Load Current Farm Failure',
  props<{ error: any }>()
);

export const clearCurrentFarm = createAction('[Farm] Clear Current Farm');

export const updateCurrentFarmSuccess = createAction(
  '[Farm] Update Current Farm Success',
  props<{ farm: Farm }>()
);
